<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="remarksModal"   tabindex="-1" role="dialog" aria-labelledby="remarksModal">
      <div class="modal-dialog modal-lg" :style="type === 'View Customer' ? 'max-width: 1000px' : '' " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              {{ type }} Remarks
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
              <div class="d-flex justify-content-between align-items-center" v-if="type === 'View Customer'">
                <div >
                  Sad Reviews: <span class="badge badge-danger mr-2">{{customerReview.sadReview}}</span>
                  Neutral Reviews: <span class="badge badge-warning mr-2">{{customerReview.naturalReview}}</span>
                  Happy Reviews: <span class="badge badge-success mr-2"> {{customerReview.happyReview}}</span>
                  Total Reviews: <span class="badge badge-default mr-2"> {{customerReview.totalReview}}</span>
                </div>
                <div class="dropdown">
                  <button  style="width: 20px!important; padding: 0!important;" title="Filter by Tags" class="filter-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-filter fs-20 mt-2"></i>
                  </button>
                  <div style="min-width: 5rem;" class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <div class="ml-10 mt-3 d-flex align-items-center">
                      <input @input="checkOption($event)" type="checkbox" v-model="selectedFilter" key="excellent" value="excellent">
                      <vue-reaction-emoji height="30px" title="Happy Reviews" width="30px" class="ml-15" :is-active="true" reaction="excellent" />
                    </div>
                    <div class="ml-10 mt-3 d-flex align-items-center">
                      <input @input="checkOption($event)" type="checkbox" v-model="selectedFilter" key="natural" value="natural">
                      <vue-reaction-emoji height="30px" title="Neutral Reviews" width="30px" class="ml-15" :is-active="true" reaction="natural" />
                    </div>
                    <div class="ml-10 mt-3 d-flex align-items-center">
                      <input @input="checkOption($event)" type="checkbox" v-model="selectedFilter" key="hate" value="hate">
                      <vue-reaction-emoji height="30px" title="Sad Reviews" width="30px" class="ml-15" :is-active="true" reaction="hate" />
                    </div>
                    <div class="ml-10 mt-3 d-flex align-items-center">
                      <input @input="checkOption($event)" v-model="selectedFilter" type="checkbox" key="all" value="all">
                      <span class="ml-20">All</span>
                    </div>
                  </div>
                </div>
              </div>
            <section v-if="type === 'Team'">
                <form @submit.prevent="submit">
                  <ValidationObserver ref="teamRemarkModal" tag="div">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Select Team member</label>
                      <ValidationProvider  rules="required"  v-slot="{ errors }">
                        <div>
                          <select v-model="commentObj.member" class="form-control">
                            <option v-for="(row, index) in allMembers" :key="index" :value="row">{{ row.firstName + ' ' + row.lastName }}</option>
                          </select>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-12 mt-10">
                      <label>Comment:</label>
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <div>
                          <textarea v-model="commentObj.comment" class="form-control" style="padding: 10px !important;" rows="4"></textarea>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                  </ValidationObserver>
                  <div class="row">
                    <div class="col-md-12">
                      <button :disabled="loading" class="btn btn-sm btn-primary pull-right" type="submit">Submit</button>
                    </div>
                  </div>
                </form>
            </section>
            <section v-else-if="type === 'Customer'">
              <div class="row">
                <div class="col-md-12 text-center">
                  <button @click="generateLink" :disabled="loading" class="btn btn-sm btn-primary">Generate Link</button>
                </div>
                <div v-if="link" class="col-md-12 mt-10">
                  <label>Link:</label>
                  <a href="javascript:void(0)" @click.prevent="copy()"><i class="fa fa-copy pull-right"></i></a>
                  <textarea readonly required v-model="link" class="form-control" rows="4">
                  </textarea>
                </div>
              </div>
            </section>
            <section v-else-if="type === 'View Team'">
              <perfect-scrollbar class="scroll-area">

              <ul style="height: 650px" class="list-group">
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-md-6 d-flex align-items-center">
                        <b>Name</b>
                      </div>
                      <div class="col-md-3 d-flex align-items-center">
                        <b>Comment</b>
                      </div>
                      <div class="col-md-3 d-flex align-items-center">
                        <b>Created At</b>
                      </div>
                    </div>
                  </li>
                   <li v-for="(row, index) in selectedRemarks" :key="index" class="list-group-item">
                    <div class="row">
                      <div class="col-md-6 d-flex align-items-center">
                        <div class="photo">
                          <img :src="`https://www.gravatar.com/avatar/${row.commentGivenBy.emailHash}?s=50`"/>
                        </div>
                        <span class="ml-10">{{ row.commentGivenBy.name }}</span>
                      </div>
                      <div class="col-md-3 d-flex align-items-center">
                        {{row.comment}}
                      </div>
                      <div class="col-md-3 d-flex align-items-center">
                        {{row.createdAt | formatDate}}
                      </div>
                    </div>
                  </li>
                </ul>
              </perfect-scrollbar>

            </section>
            <section v-else-if="type === 'View Customer'">
              <div class="row task-container">
                <div class="col-md-12">
                  <table class="table">
                    <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th class="text-center">Reaction</th>
                      <th class="text-center">Comment</th>
                      <th class="text-center">Ticket</th>
                      <th class="text-center">Created At</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <template v-if="type.includes('Team')">
                      <tbody v-for="(row, index) in selectedRemarks" :key="'current' + index">
                      <tr>
                        <td>
                          <span :class="{ 'details-control shown' : row.showMore, 'details-control' : !row.showMore }" @click="showMoreFeedback(row)"></span>
                        </td>
                        <td width="30%">
                          <div class="d-flex align-center">
                            <div class="photo">
                              <img :src="`https://www.gravatar.com/avatar/${row.commentGivenBy.emailHash}?s=50`"/>
                            </div>
                            <span class="ml-9">{{ row.commentGivenBy.name }}</span>
                          </div></td>

                        <td>
                          <vue-reaction-emoji  v-if="reactionList.includes(row.reaction)" height="30px" width="30px" :is-active="true" :reaction="row.reaction" />
                        </td>
                        <td>{{row.comment.length >15 ? `${row.comment.substring(0, 15)}...` : row.comment}}</td>
                        <td>{{row.createdAt | formatDate}}</td>
                        <td>
                          <button type="button" class="btn text-light btn-link bg-danger btn-sm mr-2 remove" @click="removeLatestFeedback(row)">
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="row.showMore" v-for="(innerRow , c_index) in row.child" :key="'child' + index + c_index+1">
                        <td></td>
                        <td width="30%">
                          <div class="d-flex align-center">
                            <div class="photo">
                              <img :src="`https://www.gravatar.com/avatar/${innerRow.commentGivenBy.emailHash}?s=50`"/>
                            </div>
                            <span class="ml-9">{{ innerRow.commentGivenBy.name }}</span>
                          </div></td>

                        <td>
                          <vue-reaction-emoji  v-if="reactionList.includes(innerRow.reaction)" height="30px" width="30px" :is-active="true" :reaction="innerRow.reaction" />
                        </td>
                        <td>{{innerRow.comment.length >15 ? `${row.comment.substring(0, 15)}...` : innerRow.comment}}</td>
                        <td>{{innerRow.createdAt | formatDate}}</td>
                        <td>
                          <button type="button" class="btn text-light btn-link bg-danger btn-sm mr-2 remove" @click="removeOldFeedback(innerRow)">
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>

                      </tbody>
                    </template>
                    <template v-else>
                      <tbody v-for="(row, index) in groupCustomerRemarks" :key="index">
                      <tr>
                        <td>
                          <span v-if="row.ticketId && row.childFeedbacks.length" :class="{ 'details-control shown' : row.showFeedback, 'details-control' : !row.showFeedback }" @click="showMoreFeedback(row)"></span>
                        </td>
                        <td width="30%">
                          <div class="d-flex align-items-center">
                            <div class="photo">
                              <img :src="`https://www.gravatar.com/avatar/${row.commentGivenBy.emailHash}?s=50`"/>
                            </div>
                            <span class="ml-9">
                               <a v-if="row.commentGivenBy.clientID" :href="`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${row.commentGivenBy.clientID}`" target="_blank">
                                 {{ row.commentGivenBy.name }}
                               </a>
                               <span v-else>{{ row.commentGivenBy.name }}</span>
                            </span>
                          </div></td>
                        <td>
                          <vue-reaction-emoji  v-if="reactionList.includes(row.reaction)" height="30px" width="30px" :is-active="true" :reaction="row.reaction" />
                        </td>
                        <td>{{row.comment}}</td>
                        <td class="text-center">
                          <a v-if="row.ticketId" :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${row.ticketId}`" target="_blank">{{row.ticketId || ''}}</a>
                          <small v-else class="text-primary"><b>Link Generated</b></small>
                        </td>
                        <td>{{row.createdAt | formatDate}}</td>
                        <td>
                          <button :disabled="loading || !adminRoles.includes(user.userType)" type="button" class="btn text-light btn-link bg-danger btn-sm mr-2 remove" @click="removeOldFeedback(row, true)">
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="openedGroups.includes(row)" v-for="(innerRow , c_index) in row.childFeedbacks" :key="'child' + index + c_index+1">
                        <td></td>
                        <td width="30%">
                          <div v-if="innerRow.commentGivenBy" class="d-flex align-items-center">
                            <div class="photo">
                              <img :src="`https://www.gravatar.com/avatar/${innerRow.commentGivenBy.emailHash}?s=50`"/>
                            </div>
                            <span class="ml-9">
                               <a v-if="row.commentGivenBy.clientID" :href="`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${row.commentGivenBy.clientID}`" target="_blank">
                                 {{ row.commentGivenBy.name }}
                               </a>
                            <span v-else>{{ row.commentGivenBy.name }}</span>
                            </span>
                          </div></td>

                        <td>
                          <vue-reaction-emoji  v-if="reactionList.includes(innerRow.reaction)" height="30px" width="30px" :is-active="true" :reaction="innerRow.reaction" />
                        </td>
                        <td>{{innerRow.comment}}</td>
                        <td class="text-center">
                          <a v-if="row.ticketId" :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${row.ticketId}`" target="_blank">{{row.ticketId || ''}}</a>
                          <small v-else class="text-primary"><b>Link Generated</b></small>
                        </td>
                        <td>{{innerRow.createdAt | formatDate}}</td>
                        <td>
                          <button :disabled="loading || user.userType !== 'admin' || user.userType !== 'super-admin'" type="button" class="btn text-light btn-link bg-danger btn-sm mr-2 remove" @click="removeOldFeedback(innerRow, false)">
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>

                      </tbody>
                    </template>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ pageCount }}
                </span>
                  <section class="dataTables_paginate paging_full_numbers">
                    <paginate
                        :pageCount="pageCount"
                        :clickHandler="goToPage"
                        :prevText="'Prev'"
                        :nextText="'Next'"
                        page-class="page-item"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                        page-link-class="page-link"
                        containerClass="pagination">
                    </paginate>
                  </section>
                </div>
              </div>

            </section>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import md5 from "crypto-js/md5";
import statisticsMixin from "@/mixins/statisticsMixin";
import swal from "sweetalert2";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import copyButtonMixin from "@/mixins/copyButtonMixin";
import {db} from "@/firebase/init";
import crypto from 'crypto-js';
import Paginate from 'vuejs-paginate'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import _ from "lodash";
import { VueReactionEmoji } from 'vue-feedback-reaction';

export default {
  name: "remarksModal",
  mixins: [statisticsMixin, copyButtonMixin],
  components: {
    PerfectScrollbar,VueReactionEmoji, Paginate, ValidationProvider , ValidationObserver
  },
    data () {
      return {
        adminRoles: ['admin', 'super-admin'],
        selectedFilter: [],
        showRecords: 10,
        pageNumber: 0,
        openedGroups: [],
        type: '',
        allMembers: [],
        selectedTeamRemarks: [],
        selectedRemarks: [],
        commentObj: {},
        loading: false,
        link: '',
        reactionList: ['hate', 'natural', 'excellent'],
        customerReview:{
          'sadReview': 0,
          'happyReview' : 0,
          'naturalReview' : 0,
          'totalReview' : 0,
        },
        sortedCustomerRemarks: [],
        show : [],
        initTables: false
      }
    },
  computed: {
    pageCount () {
      let l = parseInt(this.selectedRemarks.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
    user() {
      return this.$store.getters.user;
    },
    aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    },
    groupCustomerRemarks () {
      let allRemarks = this.selectedRemarks;
      if (this.selectedFilter.length) {
        allRemarks = allRemarks.filter(el => {
          if (this.selectedFilter.includes(el.reaction)) {
            return true;
          }
          if (el.childFeedbacks.length) {
            el.childFeedbacks.map(f => {
              return this.selectedFilter.includes(f.reaction);
            })
          }
        })
      }
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return allRemarks.slice(start, end);
    }
  },
  updated() {
    if(this.initTables){
      // this.initTable('activeFeedback');
      this.initTables = false;
    }
  },
  methods: {
    checkOption (event) {
      console.log('hNNN',event.target)
      const { value } = event.target;
      if (value === 'all') {
        // check all tags
        this.selectedFilter = ['hate', 'excellent', 'natural']
        console.log('selected filters',this.selectedFilter)
      } else {
        // remove all from array
        console.log('hello',this.selectedFilter)
        const index = this.selectedFilter.findIndex(el => el === 'all' )
        if (index !== -1) {
          this.selectedFilter.splice(index, 1)
        }
      }
    },
    goToPage (pageNum) {
      this.pageNumber = pageNum - 1;
    },
    startGrouping () {
      let parentArray = [];
      // first push those whose latest is true
      parentArray = this.selectedRemarks.filter(row => {
        if (row.latestFeedback) {
          row.showFeedback = false;
          row.childFeedbacks = [];
          return true;
        }
        return false;
      })
      this.selectedRemarks.map(el => {
        const obj = parentArray.find(row => row.latestFeedback && (el.ticketId ?  row.ticketId === el.ticketId : true));
        console.log('obj', obj)
        if (obj) {
          if (!el.latestFeedback) {
            obj.childFeedbacks.push(el)
          }
        }
        console.log('parent', parentArray)
      })
      parentArray.map(el => {
        el.childFeedbacks.sort((a,b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        })
      })
      this.selectedRemarks = parentArray;
    },
    showMoreFeedback(row){
      row.showFeedback= !row.showFeedback;
      console.log('hel', row.showFeedback)
      if (row.showFeedback) {
        this.openedGroups.push(row)
      } else {
        if (row.ticketId) {
          this.openedGroups.splice(this.openedGroups.indexOf(row.ticketId), 1)
        }
      }
    },
    copy(){
      $('#remarksModal').modal('hide');
      this.doCopy(this.link)
    },
    async generateLink() {
      try {
        this.loading= true
        const date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}));
        const obj = {
          month: date.getMonth(),
          year: date.getFullYear(),
          staffMemberDetails: {
            uid: this.user.uid,
            email: this.user.email,
            emailHash: this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : '',
            name: this.user.firstName + ' ' + this.user.lastName,
          },
          latestFeedback: false,
          status: 'pending'
        }
        const ref = await db.collection('customerRemarks').add(obj);
        this.link = `https://wpo.bigscoots.com/user/customerRemarks/${crypto.AES.encrypt(ref.id, this.aesSecret).toString().split('/').join('Por21Ld')}`

        console.log(this.link)
      }
      catch (e) {
        console.log('error on line 154', e.toString())
      }
      finally {
        this.loading= false
      }
    },
    async submit() {
      const validateResp = await this.$refs.teamRemarkModal.validate();
      if (!validateResp) { return false }
      try {
        console.log('submitting form')
        this.loading=true
        const commentObj = {
          createdAt: new Date().toISOString(),
          comment: this.commentObj.comment,
          commentGivenBy: {
            name: this.user.firstName + ' ' + this.user.lastName,
            email: this.user.email,
            emailHash: this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : '',
            uid: this.user.uid
          }
        }
        await this.incrementCountBasedOnType(this.commentObj.member, 'teamRemarks', commentObj);
        let response = await this.$http.post('utilities/send-remarks-to-slack', {
          grant_type: 'token',
          msg: this.commentObj.comment,
          details: {
            from: {
              name: this.user.firstName + ' ' + this.user.lastName,
              emailHash: this.user.email ?  md5(this.user.email.trim().toLowerCase()).toString() : ''
            },
            to: {
              name: this.commentObj.member.firstName + ' ' + this.commentObj.member.lastName,
              emailHash: this.commentObj.member.email ?  md5(this.commentObj.member.email.trim().toLowerCase()).toString() : ''
            }
          },
          type: 'Team Remarks'

        });
        console.log('response', response)
        await this.$emit('renderData')
        this.loading=false
        swal({
          title: "Success!",
          text: "You have successfully given team remarks!",
          type: "success"
        })
      }
      catch (e) {
        this.loading=false
        swal({
          title: "Error!",
          text: "Something went wrong while giving team remarks!",
          type: "error"
        })
      }
      finally {
        $('#remarksModal').modal('hide');
        $('.modal-backdrop').removeClass("modal-backdrop");
      }
    },
    calculateCustomerReview(){
      this.selectedCustomerRemarks.forEach((value) => {
          switch (value.reaction) {
            case 'natural':
              this.customerReview.naturalReview++;
              break;
            case 'excellent':
              this.customerReview.happyReview++;
              break;
            default:
              this.customerReview.sadReview++;
              break;
          }
          this.customerReview.totalReview++;
        });
    },
    async load (type, members, selectedRemarks , adminUid, month) {
      this.selectedRemarks = [];
      this.openedGroups = [];
      this.pageNumber = 0;
      this.selectedFilter = [];
      if (type.includes('Team')) {
        this.selectedRemarks = selectedRemarks
        console.log('team',this.selectedRemarks)
      } else if(type.includes('Customer')) {
        this.selectedRemarks = selectedRemarks
        this.customerReview = {
          'sadReview': 0,
          'happyReview' : 0,
          'naturalReview' : 0,
          'totalReview' : 0,
        }
        for(const row of this.selectedRemarks) {
          if (!row.latestFeedback) {
            continue
          }
          if (row.reaction === 'hate') {
            this.customerReview.sadReview += 1;
          } else if (row.reaction === 'excellent') {
            this.customerReview.happyReview += 1;
          }if (row.reaction === 'natural') {
            this.customerReview.naturalReview += 1;
          }
          this.customerReview.totalReview ++;
        }
        await this.startGrouping();
      }
      this.type = type

      this.allMembers=members
      // if(selectedCustomerRemarks){
        // await this.fetchCustomerRemarks(adminUid, month, year);
        // await this.sortFeedback(this.selectedCustomerRemarks);
        // await this.calculateCustomerReview()
        // this.reInitDataTable();
      // }
      this.commentObj={}
      this.link=null
      console.log(this.allMembers)
      if(this.$refs.teamRemarkModal){
        await this.$refs.teamRemarkModal.reset();
      }
      $('#remarksModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    reInitDataTable(){
      /* eslint-disable */
      $(`#activeFeedback`).DataTable().destroy();
      /* eslint-enable */
      this.initTables = true;
    },
    async fetchCustomerRemarks(adminUid, month, year){
      let ref= db.collection('customerRemarks').where('staffMemberDetails.uid', '==', adminUid).where('status', '==', 'completed')
      if(month === 'all') {
        ref= await ref.get();
      }
      else {
        ref= await ref.where('month', '==', month).where('year', '==', year).get()
      }
      ref.forEach(el => {
        this.selectedCustomerRemarks.push({id: el.id, ...el.data()})
      })
    },

    initTable(el) {
      console.log('Loading datatable');
      $(`#${el}`).DataTable({
        pagingType: "full_numbers",
        lengthMenu: [[5, 10, 25, -1], [5, 10, 25, "All"]],
        destroy: true,
        retrieve: true,
        deferRender: true,
        "ordering": false,
        stateSave: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search",
          size: 50
        }
      });
      /* eslint-enable */
    },
    sortFeedback(feedback){
      console.log("this feedback", feedback)
      const result = []
      feedback.forEach((value)=>{
        const alreadyExist = result.find(el => {
          return el.ticketId === value.ticketId
        })
        if (alreadyExist) {
          if (value.latestFeedback) {
            alreadyExist.current = value
          } else {
            alreadyExist.child.push(value)
          }
        } else {
          if (value.latestFeedback) {
            result.push({
              current: value,
              ticketId: value.ticketId,
              showMore: false,
              child: []
            })
          } else {
            result.push({
              current: null,
              ticketId: value.ticketId,
              showMore: false,
              child: [value]
            })
          }
        }
      })
      result.forEach((value)=>{
        value.child.sort((a,b)=>{
          const createdAtA = new Date(a.createdAt);
          const createdAtB = new Date(b.createdAt);
          return createdAtB - createdAtA;
        })
      })
      console.log("sorted Result", result)

      this.sortedCustomerRemarks = result
    },
    async removeLatestFeedback(feedback){
      try{
      const currentFeedbackReaction = feedback.current.reaction;

      await db.collection('customerRemarks').doc(feedback.current.id).delete();

      if (feedback.child.length===0){
        const ref = await db.collection('leaderboard').where('month', '==', feedback.current.month).where('year', '==', feedback.current.year).get();
        const { users } = ref.docs[0].data();
        const id = ref.docs[0].id;
        const requiredUser = users.find(el => el.uid === feedback.current.staffMemberDetails.uid);
         requiredUser.customerRemarks= requiredUser.customerRemarks-1;
         feedback.current.reaction === 'excellent' ? requiredUser.promoter-- : (feedback.current.reaction === 'hate' ? requiredUser.detractor-- : null);
         await db.collection('leaderboard').doc(id).update({ users });
         return
      }
         const prevFeedbackReaction = feedback.child[0].reaction;
         feedback.child[0].latestFeedback = true;
         await db.collection('customerRemarks').doc(feedback.child[0].id).update(feedback.child[0]);

        if(currentFeedbackReaction !== prevFeedbackReaction) {
          const ref = await db.collection('leaderboard').where('month', '==', feedback.current.month).where('year', '==', feedback.current.year).get();
          const {users} = ref.docs[0].data();
          const id = ref.docs[0].id;
          const requiredUser = users.find(el => el.uid === feedback.current.staffMemberDetails.uid);
          feedback.current.reaction === 'excellent' ? requiredUser.promoter-- : (feedback.current.reaction === 'hate' ? requiredUser.detractor-- : null);
          feedback.child[0].reaction === 'excellent' ? requiredUser.promoter++ : (feedback.child[0].reaction === 'hate' ? requiredUser.detractor++ : null);
          await db.collection('leaderboard').doc(id).update({users});
        }}
      catch(e){
        console.log(e)
      }
      finally {
        console.log("Deleted");
      }
      },

    async removeOldFeedback(feedback, changeLatest){
     try{
       console.log('feed', feedback)
       this.loading = true;
       if (changeLatest) {
         if (feedback.childFeedbacks && feedback.childFeedbacks.length) {
           console.log('inside')
           await db.collection('customerRemarks').doc(feedback.childFeedbacks[0].id).update({ latestFeedback: true})
         }
       }
       await db.collection('customerRemarks').doc(feedback.id).delete();
       this.$emit('renderData')
       $('#remarksModal').modal('hide');
     }
     catch(e){
       console.log(e)
       swal('Error', 'Something went wrong while deleting remarks', 'error')
     }
     finally {
       console.log('deleted');
       this.loading = false
     }
    }

  },
}
</script>

<style scoped>
img {
  border-radius: 50%;
}

.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  width: 15px!important;
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.filter-btn:hover {
  background-color: black!important;
  color: white !important;

}
.fs-20 {
  font-size: 15px;
}
</style>
